/* eslint-disable no-mixed-operators */
import React from 'react'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import useCommunicationsApi from '../../hooks/communications/useCommunicationsApi'
import { userTypes } from '../../utils/constants'
import { communicationTypes } from '../../utils/constants'
import cookies from '../../utils/cookies'
import { Button } from '@material-ui/core'
import CustomTable from '../customTable/CustomTable'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'

export default function CommunicationList({ building }) {
  const classes = useStyles()
  const history = useHistory()

  const [{ communicationsState }, { getCommunications }] =
    useCommunicationsApi()

  const loggedUser = JSON.parse(cookies.get('user'))

  const getBuildingApartmentLabel = (communication) => {
    // TODO -fix in backend to return apartment name
    if (communication.apartment)
      return `${communication.apartment.building.name} - ${communication.apartment.name}`
    if (communication.building && !communication.apartmentId) {
      return `${communication.building.name}`
    }
    // const apartment = apartmentsState.apartments.find(
    //   (apt) => apt.id === communication.apartmentId
    // )
    // const buildingId = apartment
    //   ? apartment.buildingId
    //   : communication.buildingId
    // const building = buildingsState.buildings.find(
    //   (build) => build.id === buildingId
    // )
    // return apartment
    //   ? `${building?.name} - ${apartment?.name}`
    //   : `${building?.name}`
  }

  const columns = [
    { id: 'title', label: 'Titulo', minWidth: 170 },
    {
      id: 'type',
      label: 'Tipo',
      minWidth: 170,
      format: (value) => getTypeDisplay(value.type),
    },
    {
      id: 'content',
      label: 'Contenido',
      minWidth: 170,
    },
    {
      id: 'receiver',
      label: 'Destinatario',
      minWidth: 170,
      format: (value) =>
        value.global
          ? 'General'
          : value.broadcastGroupId
          ? `${value?.broadcastGroup?.name}`
          : getBuildingApartmentLabel(value),
    },
    {
      id: 'createdAt',
      label: 'Fecha',
      minWidth: 170,
      format: (value) => {
        return new Date(value.createdAt).toLocaleString()
      },
    },
    {
      id: 'createdBy',
      label: 'Quien notifica',
      minWidth: 170,
      format: (value) =>
        value.createdBy
          ? `${value.createdByUser.name} ${value.createdByUser.surname}`
          : 'No registrado',
    },
  ]

  const getTypeDisplay = (type) => {
    let typeDisplay = ''
    switch (type) {
      case communicationTypes.DELIVERY:
        typeDisplay = 'Delivery'
        break
      case communicationTypes.GENERAL:
        typeDisplay = 'General'
        break
      case communicationTypes.PACKAGE:
        typeDisplay = 'Paquete'
        break
      case communicationTypes.SOS:
        typeDisplay = 'SOS'
        break
      case communicationTypes.VISITS:
        typeDisplay = 'Visitas'
        break
      case communicationTypes.ENCOMIENDA:
        typeDisplay = 'Encomienda'
        break
      default:
        typeDisplay = ''
    }
    return typeDisplay
  }

  const communications = communicationsState?.communications?.data || []

  return (
    <>
      <ListHeader
        bigTitle="Comunicaciones"
        createText="Nueva comunicación"
        canCreate={
          loggedUser.type === userTypes.admin ||
          loggedUser.type === userTypes.operator ||
          loggedUser.type === userTypes.security ||
          loggedUser.type === userTypes.securityAdmin ||
          loggedUser.type === userTypes.gestor
        }
        createRedirect={() => history.push('nueva-comunicacion')}
        secondaryButtonText="Grupos de difusión"
        secondaryButtonRedirect={() => history.push('/nuevo-grupo-de-difusion')}
      />
      <CustomTable
        loading={communicationsState.isLoading}
        columns={columns}
        data={communications}
        getData={getCommunications}
        buildingFilter={!building}
        building={building}
        apartmentFilter={true}
        customFilters={[
          {
            field: 'type',
            label: 'Tipo de comunicación',
            type: 'select',
            options: [
              { value: '', label: 'Todas' },
              { value: communicationTypes.GENERAL, label: 'General' },
              { value: communicationTypes.SOS, label: 'SOS' },
              { value: communicationTypes.DELIVERY, label: 'Delivery' },
              { value: communicationTypes.PACKAGE, label: 'Paquete' },
              { value: communicationTypes.VISITS, label: 'Visitas' },
            ],
          },
        ]}
      ></CustomTable>
    </>
  )
}
